export function getTimeZoneName(timezones, userTimeZoneId) {
  return timezones?.find(({ id }) => id === userTimeZoneId)?.name;
}
